"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.symbol.description.js");

var _ = require("./");

class EvaluationRemedy {
  static thaw(evaluationRemedyObj) {
    if (evaluationRemedyObj == null) return null;
    const evaluationRemedy = new EvaluationRemedy();
    if (evaluationRemedyObj.id != null) evaluationRemedy.setId(evaluationRemedyObj.id);
    if (evaluationRemedyObj.description != null) evaluationRemedy.setDescription(evaluationRemedyObj.description);
    if (evaluationRemedyObj.remedyType != null) evaluationRemedy.setRemedyType(evaluationRemedyObj.remedyType);
    if (evaluationRemedyObj.productCategoryId != null) evaluationRemedy.setProductCategoryId(evaluationRemedyObj.productCategoryId);
    if (evaluationRemedyObj.evaluationVersionId != null) evaluationRemedy.setEvaluationVersionId(evaluationRemedyObj.evaluationVersionId);
    if (evaluationRemedyObj.productCategory != null) evaluationRemedy.setProductCategory(_.ProductCategory.thaw(evaluationRemedyObj.productCategory));
    if (evaluationRemedyObj.evaluationVersion != null) evaluationRemedy.setEvaluationVersion(_.EvaluationVersion.thaw(evaluationRemedyObj.evaluationVersion));
    if (evaluationRemedyObj.questions != null) evaluationRemedy.setQuestions(_.EvaluationQuestion.thawList(evaluationRemedyObj.questions));
    return evaluationRemedy;
  }

  static thawList(evaluationRemedyObjList) {
    if (evaluationRemedyObjList == null) return [];
    var evaluationRemedys = [];

    for (var i = 0; i < evaluationRemedyObjList.length; i++) {
      evaluationRemedys.push(EvaluationRemedy.thaw(evaluationRemedyObjList[i]));
    }

    return evaluationRemedys;
  }

  static freeze(evaluationRemedy) {
    if (evaluationRemedy == null) return null;
    var evaluationRemedyObj = {};
    if (evaluationRemedy.getId() != null) evaluationRemedyObj.id = evaluationRemedy.getId();
    if (evaluationRemedy.getDescription() != null) evaluationRemedyObj.description = evaluationRemedy.getDescription();
    if (evaluationRemedy.getRemedyType() != null) evaluationRemedyObj.remedyType = evaluationRemedy.getRemedyType();
    if (evaluationRemedy.getProductCategoryId() != null) evaluationRemedyObj.productCategoryId = evaluationRemedy.getProductCategoryId();
    if (evaluationRemedy.getEvaluationVersionId() != null) evaluationRemedyObj.evaluationVersionId = evaluationRemedy.getEvaluationVersionId();
    if (evaluationRemedy.getProductCategory() != null) evaluationRemedyObj.productCategory = _.ProductCategory.freeze(evaluationRemedy.getProductCategory());
    if (evaluationRemedy.getEvaluationVersion() != null) evaluationRemedyObj.evaluationVersion = _.EvaluationVersion.freeze(evaluationRemedy.getEvaluationVersion());
    if (evaluationRemedy.getQuestions() != null) evaluationRemedyObj.questions = _.EvaluationQuestion.freezeList(evaluationRemedy.getQuestions());
    return evaluationRemedyObj;
  }

  static freezeList(evaluationRemedys) {
    if (evaluationRemedys == null) return [];
    var evaluationRemedyObjList = [];

    for (var i = 0; i < evaluationRemedys.length; i++) {
      evaluationRemedyObjList.push(EvaluationRemedy.freeze(evaluationRemedys[i]));
    }

    return evaluationRemedyObjList;
  }

  constructor() {
    this.setId(null);
    this.setDescription(null);
    this.setRemedyType(null);
    this.setProductCategoryId(null);
    this.setEvaluationVersionId(null);
    this.setProductCategory(null);
    this.setEvaluationVersion(null);
    this.setQuestions(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setDescription(description) {
    this.description = description;
  }

  setRemedyType(remedyType) {
    this.remedyType = remedyType;
  }

  setProductCategoryId(productCategoryId) {
    this.productCategoryId = productCategoryId;
  }

  setEvaluationVersionId(evaluationVersionId) {
    this.evaluationVersionId = evaluationVersionId;
  }

  setProductCategory(productCategory) {
    this.productCategory = productCategory;
  }

  setEvaluationVersion(evaluationVersion) {
    this.evaluationVersion = evaluationVersion;
  }

  setQuestions(questions) {
    this.questions = questions;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getDescription() {
    return this.description;
  }

  getRemedyType() {
    return this.remedyType;
  }

  getProductCategoryId() {
    return this.productCategoryId;
  }

  getEvaluationVersionId() {
    return this.evaluationVersionId;
  }

  getProductCategory() {
    return this.productCategory;
  }

  getEvaluationVersion() {
    return this.evaluationVersion;
  }

  getQuestions() {
    return this.questions;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluationRemedy;